const ReqState = {
  INIT: 0,
  DOING:  1,
  DONE:  2,
  ERROR: 255,
}

export {
  ReqState as default,
  ReqState,
};
